import React, { Component } from 'react';
import '../css/components/Loading.css';
import spinnerLighVisual from "../assets/img/spinner-light_Visual.gif";
class Loading extends Component {
  render() {
	let urlImagenSpinner = spinnerLighVisual;
	let mensajeClassName = this.props.light ? "loading__div-label-light": "loading__div-label"
    return (
      <div className="loading__div-main">
        <img alt="imgLoading" src={urlImagenSpinner} className="loading__image" id={this.props.id} />
        <div className={mensajeClassName}>
          <label>{this.props.mensaje}</label>
        </div>
      </div>
    );
  }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading.js